import { render, staticRenderFns } from "./ContextGroup.vue?vue&type=template&id=0d334696&"
import script from "./ContextGroup.vue?vue&type=script&lang=ts&"
export * from "./ContextGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ContextGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d334696')) {
      api.createRecord('0d334696', component.options)
    } else {
      api.reload('0d334696', component.options)
    }
    module.hot.accept("./ContextGroup.vue?vue&type=template&id=0d334696&", function () {
      api.rerender('0d334696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/groupby/ContextGroup.vue"
export default component.exports